import { render, staticRenderFns } from "./TaxInformation.vue?vue&type=template&id=9db857ce&"
import script from "./TaxInformation.vue?vue&type=script&lang=js&"
export * from "./TaxInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports